// extracted by mini-css-extract-plugin
module.exports = {"modal__comment-button":"EOcfjtNxgydznoEcUg6jk","modal__text-area":"_17tN-pAUdj4Qa9qahVS8ma"};